import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OrcamentosEPacotesListarRoutingModule } from './orcamentos-e-pacotes-listar-routing.module';
import { OrcamentosEPacotesListarComponent } from './orcamentos-e-pacotes-listar.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessagesModule } from 'primeng/messages';
import { DividerModule } from 'primeng/divider';
import { ConfirmationService } from 'primeng/api';
import { InputTextModule } from 'primeng/inputtext';


@NgModule({
  declarations: [
    OrcamentosEPacotesListarComponent
  ],
  imports: [
    CommonModule,
    OrcamentosEPacotesListarRoutingModule,
    TableModule,
    InputTextModule,
    ConfirmDialogModule,
    DropdownModule,
    ProgressSpinnerModule,
    MessagesModule,
    DividerModule
  ],
  providers: [ConfirmationService]
})
export class OrcamentosEPacotesListarModule { }
